import React from "react";
import { withRouter } from "react-router-dom";
import RaisedButton from "../components/RaisedButton";

import * as routes from "../constants/routes";

import { auth } from "../firebase";
import Spinner from "../components/Spinner";

const INITIAL_STATE = {
  email: "",
  password: "",
  error: ""
};

class PageLogin extends React.Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
    this.formRef = React.createRef();
  }

  signIn(e) {
    auth
      .doSignInWithEmailAndPassword(this.state.email, this.state.password)
      .then(authUser => {
        this.setState(INITIAL_STATE);
        this.props.history.push(routes.HOME);
      })
      .catch(error => {
        this.setState({ error: error });
      });

    e.preventDefault();
  }

  render() {
    return (
      <div
        style={{
          width: 300,
          margin: "100px auto",
          backgroundColor: "#fff",
          padding: "32px",
          boxShadow:
            "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)"
        }}
      >
        <form id="loginForm" ref={this.formRef} onSubmit={e => this.signIn(e)}>
          <img
            src={require("../media/Freeway-Logo.png")}
            alt="Logo"
            style={{ marginBottom: "20px" }}
          />

          <input
            id="email"
            onChange={e => this.setState({ email: e.target.value })}
            placeholder="E-Mail Adresse"
            type="text"
          />
          <input
            id="password"
            onChange={e => this.setState({ password: e.target.value })}
            placeholder="Passwort"
            type="password"
            style={{ marginTop: "5px", marginBottom: "20px" }}
          />

          <p
            style={{
              marginTop: "5px",
              marginBottom: "20px",
              fontSize: 12,
              color: "red"
            }}
          >
            {this.state.error.message}
          </p>

          <center>
            {/*<Spinner />*/}
            <RaisedButton label="Anmelden" onClick={() => {}} />
          </center>
        </form>
      </div>
    );
  }
}

export default withRouter(PageLogin);



// WEBPACK FOOTER //
// ./src/pages/PageLogin.js